import React, { useEffect, useState, useRef } from 'react';
import PropTypes, { arrayOf } from 'prop-types';
import { connect } from 'react-redux';
import {
  DoubleArrow, Check, Add, Clear, ArrowBack,
} from '@mui/icons-material';
import { LinearProgress, Stack } from '@mui/material';
import { toaster } from 'evergreen-ui';
import { popOver } from '../../assets/templates';
import ToggleButton from '../ui/ToggleButton';
import Select from '../ui/Select';
import validateRequiredFields, { convertBase64, toInteger } from '../../utilities';
import uploadImage from '../../api/uploadImage';
import Modal from '../ui/Modal';
import Designs from '../../api/designs';

const SelectDesignView = ({
  view,
  setView,
  calculationsData,
  setCalculationsData,
}) => {
  const [isNextStepAvailable, setIsNextStepAvailable] = useState(false);
  const [validateSubmit, setValidateSubmit] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [showModal, setShowModal] = useState({
    saveDesign: false, loadDesign: false, showDesigns: false,
  });
  const [newDesign, setNewDesign] = useState({
    cost: 0, width: 0, length: 0, designName: '', img: {},
  });
  const [userDesigns, setUserDesigns] = useState([]);
  const [count, setCount] = useState(0);
  const id = localStorage.getItem('id');
  const element = useRef();

  const handleImage = async () => {
    // si ya existen archivos los convierte en base64 para enviarlos junto con los nuevos
    const uploadedImage = document.getElementById('upload-design-file')?.files;
    let imageData = null;

    /* eslint no-await-in-loop: "off" */
    const fileDataBase64 = (await convertBase64(uploadedImage[0])).split('base64,')[1];
    // 'image/png'
    // se guardan los archivos en un array de archivos si devuelve la funcion un base64 valido
    imageData = {
      img: {
        base64: fileDataBase64,
        filename: uploadedImage[0].name,
        type: 'image/x-png',
      },
    };
    // convierte el base64 a una url S3
    const imageURL = await uploadImage.imageToS3(imageData);
    setCalculationsData({
      ...calculationsData,
      imgDesign: { ...imageData.img, url: (imageURL.url || null) },
    });
  };
  const handleCreateNewDesign = (e) => {
    e.preventDefault();
    if (!newDesign?.img?.base64) return toaster.warning('Es necesario subir una imagen');
    setIsLoading(true);
    Designs.createDesign(newDesign, id)
      .then((response) => {
        if (response.id) {
          toaster.success('Diseño guardado', {
            id: 'forbidden-action',
            duration: 1,
          });
          setCount(count + 1);
          return;
        }
        toaster.danger('Algo salio mal, vuelva interalo pronto', {
          id: 'forbidden-action',
          duration: 1.5,
        });
      })
      .catch(() => {
        toaster.danger('Algo salio mal, vuelva interalo pronto', {
          id: 'forbidden-action',
          duration: 1.5,
        });
      });
    return undefined;
  };

  const handleDesignImage = async () => {
    const file = document.getElementById('add-new-design-img')?.files;
    if (file?.length > 0) {
      const completeBase64 = (await convertBase64(file[0]));
      const base64 = completeBase64.split('base64,')[1];
      return setNewDesign((prevState) => ({
        ...prevState,
        img: {
          filename: file[0]?.name, base64, type: ('image/x-png'), completeBase64,
        },
      }));
    }
    return setNewDesign({ ...newDesign, img: {} });
  };

  useEffect(() => {
    Designs.getDesignsByUser(id)
      .then((response) => setUserDesigns(response))
      .catch((err) => console.log(err));
    setIsLoading(false);
  }, [count]);

  /**
   * obtiene el costo por diseño, y numero de diseños por pieza de material, unicamente del material principal
   */
  useEffect(() => {
    const mockValues = [...calculationsData.material.values];
    const newValues = mockValues.map((material) => {
      if (material?.designLength && material?.designWidth) {
        const designArea = (material.designWidth * material.designLength);
        const designsPerPiece = Math.floor((calculationsData.machine.lengthCut * calculationsData.machine.witdhCut)
        / designArea);

        const elementValues = {
          ...material,
          designsPerPiece,
          designsPerSheet: Math.floor(designsPerPiece * material.totalPiecesPerSheet),
          costPerDesign: material.costPerPiece / designsPerPiece,
        };
        return elementValues;
      }
      return material;
    });

    setCalculationsData({
      ...calculationsData,
      material: {
        ...calculationsData.material,
        values: newValues,
      },
      design: {
        ...calculationsData.design,
        costPerDesign: newValues.reduce((previousValue, currentValue) => previousValue + currentValue.costPerDesign, 0),
      },
    });
    if (isNextStepAvailable) return;
    setIsNextStepAvailable(true);
  }, [JSON.stringify(calculationsData.material.values)]);

  useEffect(() => {
    if (calculationsData?.design?.typeOfWork === 'cut-and-engrave'
    && calculationsData?.design?.engraveWorkTime > 0 && calculationsData?.design?.engravePower?.potencia_kwh > 0
    && calculationsData?.design?.cutWorkTime > 0 && calculationsData?.design?.cutPower?.potencia_kwh > 0) {
      const consumption = (calculationsData.design.cutPower.potencia_kwh * (calculationsData.design.cutWorkTime / 60)
      + calculationsData.design.engravePower.potencia_kwh * (calculationsData.design.engraveWorkTime / 60));

      setCalculationsData({
        ...calculationsData,
        design: {
          ...calculationsData.design,
          kWhConsumedByDesign: consumption,
        },
      });
    } else if (calculationsData?.design?.typeOfWork === 'cut-or-engrave'
    && calculationsData?.design?.cutWorkTime > 0 && calculationsData?.design?.cutPower?.potencia_kwh > 0) {
      const consumption = (calculationsData.design.cutPower.potencia_kwh * (calculationsData.design.cutWorkTime / 60));

      setCalculationsData({
        ...calculationsData,
        design: {
          ...calculationsData.design,
          kWhConsumedByDesign: consumption,
        },
      });
    }
  }, [calculationsData?.design?.engraveWorkTime, calculationsData?.design?.engravePower?.potencia_kwh,
    calculationsData?.design?.cutPower?.potencia_kwh, calculationsData?.design?.cutWorkTime]);

  useEffect(() => {
    setValidateSubmit(validateRequiredFields(document.querySelectorAll('[required]')));
  }, [calculationsData.design]);

  return (
    <>
      <form
        ref={element}
        onSubmit={(e) => {
          e.preventDefault();
          setView(view + 1);
        }}
        className="main-container"
        style={{ position: 'relative', marginBottom: '50px' }}
      >

        <button
          onClick={() => setView(view - 1)}
          id="button"
          className="simple-button"
          type="button"
          style={{ position: 'absolute', top: '0', left: '0' }}
        >
          <DoubleArrow sx={{ transform: 'rotate(180deg)' }} />
          Paso anterior
        </button>

        {isNextStepAvailable
        && (
          <button
            id="button"
            className="simple-button"
            type="submit"
            data-available={validateSubmit}
            data-disabled={!validateSubmit}
            style={{ position: 'absolute', top: '0', right: '0' }}
          >
            <DoubleArrow />
            Siguiente paso
          </button>
        )}

        <div
          className="icon-wrapper item-container add-box"
          style={{
            width: '300px', display: 'flex', justifyContent: 'space-around', alignItems: 'center', height: '70px',
          }}
        >
          <input
            style={{ display: 'none' }}
            id="upload-design-file"
            onChange={handleImage}
            type="file"
            accept="image/*"
          />
          <p>Subir Diseño</p>
          <button
            style={{ width: '30px', height: '30px' }}
            onClick={() => setShowModal((prevState) => ({ ...prevState, loadDesign: true }))}
            type="button"
            className="simple-button"
            // data-title={popOver[47]}
          >
            <Add style={{ fontSize: '20px', alignItems: 'center', verticalAlign: 'middle' }} />
          </button>
        </div>

        {calculationsData.material.values?.length > 0
        && (
          <div style={{ margin: '0 auto', maxWidth: '600px' }}>
            {React.Children.toArray(calculationsData.material.values.map((material, index) => (
              <div style={{ margin: '50px 0' }} className="appear item-container">
                <div className="aligned-items">
                  <p>{`Material: ${material.name}`}</p>
                </div>
                <div className="aligned-items icon-wrapper">
                  <div className="icon-wrapper">
                    <p>Alto del diseño</p>
                    <div data-title={popOver[25]}>
                      <img
                        alt="icon"
                        src="https://ramonsgt.github.io/calculadora-de-inversion-sagaon/assets/icons/question-mark.svg"
                      />
                    </div>
                  </div>
                  <div style={{ position: 'relative', width: '100%' }}>
                    <input
                      placeholder="10"
                      className="select"
                      type="number"
                      required
                      value={material?.designWidth || ''}
                      onChange={(e) => {
                        setCalculationsData({
                          ...calculationsData,
                          material: {
                            ...calculationsData.material,
                            values: calculationsData.material.values.map((item, materialIndex) => (
                              materialIndex === index ? { ...item, designWidth: Number(e.target.value) } : item)),
                          },
                        });
                      }}
                    />
                    <p className="end-input-icon">cm</p>
                  </div>
                </div>
                <div className="aligned-items" style={{ marginBottom: '30px' }}>
                  <div className="icon-wrapper">
                    <p>Largo del diseño</p>
                    <div data-title={popOver[26]}>
                      <img
                        alt="icon"
                        src="https://ramonsgt.github.io/calculadora-de-inversion-sagaon/assets/icons/question-mark.svg"
                      />
                    </div>
                  </div>
                  <div style={{ position: 'relative', width: '100%' }}>
                    <input
                      placeholder="10"
                      className="select"
                      type="number"
                      required
                      value={material?.designLength || ''}
                      onChange={(e) => {
                        setCalculationsData({
                          ...calculationsData,
                          material: {
                            ...calculationsData.material,
                            values: calculationsData.material.values.map((item, materialIndex) => (
                              materialIndex === index ? { ...item, designLength: Number(e.target.value) } : item)),
                          },
                        });
                      }}
                    />
                    <p className="end-input-icon">cm</p>
                  </div>
                </div>

                {(material.designLength > 0 && material.designWidth > 0)
                && (
                <div className="design-measures content-wrapper appear aligned-items">
                  <div className="icon-wrapper">
                    <p style={{ display: 'initial' }}>Número de diseños por hoja completa</p>
                    <div data-title={popOver[28]}>
                      <img
                        alt="icon"
                        src="https://ramonsgt.github.io/calculadora-de-inversion-sagaon/assets/icons/question-mark.svg"
                      />
                    </div>
                    <input
                      className="select"
                      type="number"
                      disabled
                      value={material?.designsPerSheet || 0}
                    />
                  </div>
                  <div className="icon-wrapper">
                    <p style={{ display: 'initial' }}>Número de diseños por pieza de hoja</p>
                    <div data-title={popOver[39]}>
                      <img
                        alt="icon"
                        src="https://ramonsgt.github.io/calculadora-de-inversion-sagaon/assets/icons/question-mark.svg"
                      />
                    </div>
                    <input
                      className="select"
                      type="number"
                      required
                      data-disabled="true"
                      placeholder="0"
                      onInvalid={(e) => {
                        if (!e.target.value) {
                          e.target.setCustomValidity(`El numero de diseños debe ser mayor a 0,
                          esto es porque las medidas de tu diseño es mayor a las medidas del equipo a utilizar`);
                        } else {
                          e.target.setCustomValidity('');
                        }
                      }}
                      value={material?.designsPerPiece || ''}
                    />
                  </div>
                  <div className="icon-wrapper">
                    <p style={{ display: 'initial' }}>
                      Costo por diseño
                      (
                      {calculationsData.currentCurrency.currencyCode}
                      )
                    </p>
                    <div data-title={popOver[38]}>
                      <img
                        alt="icon"
                        src="https://ramonsgt.github.io/calculadora-de-inversion-sagaon/assets/icons/question-mark.svg"
                      />
                    </div>
                    <div style={{ position: 'relative' }}>
                      <input
                        placeholder="0"
                        className="select"
                        type="number"
                        disabled
                        value={toInteger(material?.costPerDesign, 2) || 0}
                      />
                      <p className="start-input-icon">{calculationsData.currentCurrency.symbol}</p>
                    </div>
                  </div>
                </div>
                )}
              </div>
            )))}
          </div>
        )}

        {calculationsData.material.values.every((material) => material.costPerPiece > 0)
        && (
        <div style={{ maxWidth: '600px', margin: '0 auto 30px auto' }} className="appear aligned-items justify-items">
          <ToggleButton
            value={calculationsData?.design?.typeOfWork === 'cut-or-engrave'}
            setValue={() => setCalculationsData({
              ...calculationsData,
              design: {
                ...calculationsData.design,
                typeOfWork: 'cut-or-engrave',
              },
            })}
            style={{ marginRight: '50px' }}
            textLabel="CORTAR O GRABAR"
          />
          <ToggleButton
            value={calculationsData?.design?.typeOfWork === 'cut-and-engrave'}
            setValue={() => setCalculationsData({
              ...calculationsData,
              design: {
                ...calculationsData.design,
                typeOfWork: 'cut-and-engrave',
              },
            })}
            textLabel="CORTAR Y GRABAR"
          />
        </div>
        )}

        {(calculationsData?.design?.typeOfWork
        && calculationsData.design?.costPerDesign >= 0)
        && (
        <div
          className="appear aligned-items item-container icon-wrapper content-wrapper"
          style={{ justifyContent: 'space-around', margin: '0 auto' }}
        >
          <div className="work-time-container">
            <p style={{ margin: '0' }} className="mr-t-0">
              {(calculationsData?.machine.name)
                && (<Check className="appear" sx={{ color: 'green', fontSize: '15px' }} />)}
              Potencia de Corte (%)
            </p>
            <div data-title={popOver[0]}>
              <img
                alt="icon"
                src="https://ramonsgt.github.io/calculadora-de-inversion-sagaon/assets/icons/question-mark.svg"
              />
            </div>
            <Select
              value={calculationsData?.design?.cutPower?.porcentaje_trabajo || ''}
              setValue={(value) => setCalculationsData({
                ...calculationsData,
                design: {
                  ...calculationsData.design,
                  cutPower: (calculationsData?.machineConsumptions?.length > 0
                  && calculationsData?.machineConsumptions.filter((item) => (
                    item.porcentaje_trabajo === Number(value)))[0]),
                },
              })}
              options={calculationsData?.machineConsumptions}
              property="porcentaje_trabajo"
              placeholder="Seleccionar opcion"
              required
            />
          </div>
          {/* <ProgressBar
            percentage={calculationsData.design?.cutPower}
            progressValue={calculationsData.design?.cutPower}
            label="Porcentaje de Potencia de Corte"
            handleChange={(e) => {
              if (e.key !== 'Enter' || Number(e.target.value) > 101 || Number(e.target.value) < 1) return;
              setCalculationsData({
                ...calculationsData,
                design: {
                  ...calculationsData.design,
                  cutPower: Number(e.target.value),
                },
              });
            }}
          />
          <div style={{ textAlign: 'center', margin: '0 20px' }}>
            <button
              className="primary-button"
              style={{ width: '25px', height: '25px', padding: '0' }}
              type="button"
              onClick={() => {
                setCalculationsData({
                  ...calculationsData,
                  design: {
                    ...calculationsData.design,
                    cutPower: (calculationsData.design?.cutPower || 0) + 1,
                  },
                });
              }}
            >
              +
            </button>
            <button
              className="secondary-button"
              style={{ width: '25px', height: '25px', padding: '0' }}
              type="button"
              onClick={() => {
                if (calculationsData.design?.cutPower === 0) return;
                setCalculationsData({
                  ...calculationsData,
                  design: {
                    ...calculationsData.design,
                    cutPower: (calculationsData.design?.cutPower || 0) - 1,
                  },
                });
              }}
            >
              -
            </button>
          </div> */}
          <div>
            <p style={{ margin: '0' }}>Duracion de trabajo</p>
            <div className="i" data-title={popOver[27]}>
              <img
                alt="icon"
                src="https://ramonsgt.github.io/calculadora-de-inversion-sagaon/assets/icons/question-mark.svg"
              />
            </div>
            <div className="work-time-container">
              <input
                placeholder="60"
                className="select"
                type="number"
                required
                value={calculationsData?.design?.cutWorkTime || ''}
                onChange={(e) => setCalculationsData({
                  ...calculationsData,
                  design: {
                    ...calculationsData.design,
                    cutWorkTime: Number(e.target.value),
                  },
                })}
              />
              <p className="end-input-icon">minutos</p>
            </div>
          </div>
        </div>
        )}

        {(calculationsData?.design?.typeOfWork === 'cut-and-engrave'
        && calculationsData.design?.costPerDesign >= 0)
        && (
          <div
            className="appear aligned-items item-container icon-wrapper content-wrapper"
            style={{ justifyContent: 'space-around', margin: '0 auto' }}
          >
            <div className="work-time-container">
              <p style={{ margin: '0' }} className="mr-t-0">
                {(calculationsData?.machine.name)
                  && (<Check className="appear" sx={{ color: 'green', fontSize: '15px' }} />)}
                Potencia de Grabado (%)
              </p>
              <div data-title={popOver[0]}>
                <img
                  alt="icon"
                  src="https://ramonsgt.github.io/calculadora-de-inversion-sagaon/assets/icons/question-mark.svg"
                />
              </div>
              <Select
                value={calculationsData?.design?.engravePower?.porcentaje_trabajo || ''}
                setValue={(value) => setCalculationsData({
                  ...calculationsData,
                  design: {
                    ...calculationsData.design,
                    engravePower: (calculationsData?.machineConsumptions?.length > 0
                      && calculationsData?.machineConsumptions.filter((item) => (
                        item.porcentaje_trabajo === Number(value)))[0]),
                  },
                })}
                options={calculationsData?.machineConsumptions}
                property="porcentaje_trabajo"
                placeholder="Seleccionar opcion"
                required
              />
            </div>
            {/* <ProgressBar
              percentage={calculationsData.design?.engravePower}
              progressValue={calculationsData.design?.engravePower}
              label="Porcentaje de Potencia de grabado"
              handleChange={(e) => {
                if (e.key !== 'Enter' || Number(e.target.value) > 101 || Number(e.target.value) < 1) return;
                setCalculationsData({
                  ...calculationsData,
                  design: {
                    ...calculationsData.design,
                    engravePower: Number(e.target.value),
                  },
                });
              }}
            />
            <div style={{ textAlign: 'center', margin: '0 20px' }}>
              <button
                className="primary-button"
                style={{ width: '25px', height: '25px', padding: '0' }}
                type="button"
                onClick={() => {
                  setCalculationsData({
                    ...calculationsData,
                    design: {
                      ...calculationsData.design,
                      engravePower: (calculationsData.design?.engravePower || 0) + 1,
                    },
                  });
                }}
              >
                +
              </button>
              <button
                className="secondary-button"
                style={{ width: '25px', height: '25px', padding: '0' }}
                type="button"
                onClick={() => {
                  if (calculationsData.design?.engravePower === 0) return;
                  setCalculationsData({
                    ...calculationsData,
                    design: {
                      ...calculationsData.design,
                      engravePower: (calculationsData.design?.engravePower || 0) - 1,
                    },
                  });
                }}
              >
                -
              </button>
            </div> */}
            <div>
              <p style={{ margin: '0' }}>Duracion de trabajo</p>
              <div className="i" data-title={popOver[27]}>
                <img
                  alt="icon"
                  src="https://ramonsgt.github.io/calculadora-de-inversion-sagaon/assets/icons/question-mark.svg"
                />
              </div>
              <div className="work-time-container">
                <input
                  placeholder="60"
                  className="select"
                  type="number"
                  required
                  value={calculationsData?.design?.engraveWorkTime || ''}
                  onChange={(e) => setCalculationsData({
                    ...calculationsData,
                    design: {
                      ...calculationsData.design,
                      engraveWorkTime: Number(e.target.value),
                    },
                  })}
                />
                <p className="end-input-icon">minutos</p>
              </div>
            </div>
          </div>
        )}
      </form>

      {showModal.loadDesign
      && (
      <Modal
        style={{
          top: '100px',
          left: `calc(50% - ${385 - ((window.innerWidth - element.current.offsetWidth) / 2)}px)`,
        }}
        className="load-design-modal"
      >
        <form style={{ marginTop: '20px' }} className="aligned-items" onSubmit={(e) => handleCreateNewDesign(e)}>
          {(!showModal.showDesigns && !showModal.saveDesign)
          && (
          <>
            <div
              style={{ cursor: 'pointer', marginRight: '30px', textAlign: 'center' }}
              role="none"
              onClick={() => setShowModal((prevState) => ({ ...prevState, showDesigns: true }))}
            >
              <img className="load-save-design-image" alt="save-img" src="https://i.imgur.com/8cRicM8.jpg" />
              <p>Seleccione un diseño guardado o guarde uno nuevo</p>
            </div>
            <div
              role="none"
              onClick={() => {
                document.getElementById('upload-design-file').click();
                setShowModal((prevState) => ({ ...prevState, loadDesign: false }));
              }}
              style={{ cursor: 'pointer', textAlign: 'center' }}
            >
              <img className="load-save-design-image" alt="load-img" src="https://imgur.com/1ycr4h5.jpg" />
              <p>Seleccione una imagen de su navegador, unicamente para mostrar en la cotizacion</p>
            </div>
          </>
          )}
          <button
            style={{ position: 'absolute', top: '5px', right: '20px' }}
            className="simple-button"
            type="button"
            onClick={() => setShowModal(({ saveDesign: false, loadDesign: false, showDesigns: false }))}
          >
            <Clear style={{ fontSize: '15px' }} />
          </button>

          {showModal.showDesigns
          && (
            <div style={{ width: '100%' }}>
              <button
                style={{ position: 'absolute', top: '5px', left: '20px' }}
                className="simple-button"
                type="button"
                onClick={() => setShowModal((prevState) => ({ ...prevState, showDesigns: false }))}
              >
                <ArrowBack style={{ fontSize: '15px' }} />
              </button>
              <p style={{ textAlign: 'center' }}>
                {`Galeria de diseños de: ${localStorage.getItem('user-name')}`}
              </p>
              <div className="user-designs-container">
                <div
                  role="none"
                  className="user-designs-wrapper"
                  style={{ backgroundColor: '#dedede', boxShadow: 'none' }}
                  onClick={() => setShowModal((prevState) => ({ ...prevState, showDesigns: false, saveDesign: true }))}
                >
                  <Add style={{ fontSize: '50px', marginTop: '60px', width: '150px' }} />
                  <p style={{ marginTop: '38px' }}>
                    Agregar nuevo diseño
                  </p>
                </div>
                {userDesigns?.length > 0 && userDesigns.map((design) => (
                  <div
                    key={design.id}
                    role="none"
                    className="user-designs-wrapper"
                    onClick={() => {
                      const mockValues = calculationsData.material.values.map((material) => {
                        const values = {
                          ...material,
                          designLength: design.length,
                          designWidth: design.width,
                        };
                        return values;
                      });
                      setCalculationsData({
                        ...calculationsData,
                        imgDesign: {
                          url: design.img_url,
                          name: design.name,
                          base64: design.img_url,
                          completeBase64: design.img_url,
                        },
                        material: {
                          ...calculationsData.material,
                          values: mockValues,
                        },
                      });
                    }}
                  >
                    <img
                      alt="design"
                      src={design.img_url}
                    />
                    <p>{design.name}</p>
                  </div>
                ))}
              </div>
            </div>
          )}

          {showModal.saveDesign
          && (
          <div style={{ width: '100%', padding: '20px 200px' }} onSubmit={(e) => handleCreateNewDesign(e)}>
            <div>
              <div className="icon-wrapper">
                <p>Nombre del diseño</p>
                <input
                  type="text"
                  value={newDesign.designName || ''}
                  onChange={(e) => {
                    setNewDesign((prevState) => ({ ...prevState, designName: e.target.value }));
                  }}
                  required
                />
              </div>
              <div className="icon-wrapper">
                <p>Alto del material</p>
                <div style={{ position: 'relative' }}>
                  <input
                    type="number"
                    value={newDesign.width || ''}
                    onChange={(e) => {
                      setNewDesign((prevState) => ({ ...prevState, width: Number(e.target.value) }));
                    }}
                    required
                  />
                  <p className="end-input-icon">cm</p>
                </div>
              </div>
              <div className="icon-wrapper">
                <p>Largo del material</p>
                <div style={{ position: 'relative' }}>
                  <input
                    type="number"
                    value={newDesign.length || ''}
                    onChange={(e) => {
                      setNewDesign((prevState) => ({ ...prevState, length: Number(e.target.value) }));
                    }}
                    required
                  />
                  <p className="end-input-icon">cm</p>
                </div>
              </div>
            </div>
            <div>
              <input
                id="add-new-design-img"
                accept="image/*, .dxf"
                type="file"
                onChange={handleDesignImage}
              />
              {/* {newDesign?.img?.completeBase64
              && (
                <img
                  alt="img"
                  src={newDesign.img?.completeBase64 || ''}
                  style={{
                    maxWidth: '350px', height: '200px', objectFit: 'contain', display: 'flex', margin: 'auto',
                  }}
                  required
                />
              )} */}
            </div>
            <button
              style={{ position: 'absolute', top: '5px', left: '20px' }}
              className="simple-button"
              type="button"
              onClick={() => setShowModal((prevState) => ({ ...prevState, saveDesign: false, showDesigns: true }))}
            >
              <ArrowBack style={{ fontSize: '15px' }} />
            </button>
            {isLoading
              ? (
                <Stack sx={{ width: '200px', color: 'grey.500', margin: '33px auto' }} spacing={2}>
                  <LinearProgress color="inherit" />
                </Stack>
              )
              : (
                <button
                  onTransitionEnd={() => {}}
                  id="submit-button"
                  disabled={isLoading}
                  className="select-button"
                  type="submit"
                >
                  GUARDAR
                </button>
              )}
          </div>
          )}
        </form>
      </Modal>
      )}
    </>
  );
};

SelectDesignView.propTypes = {
  view: PropTypes.number.isRequired,
  setView: PropTypes.func.isRequired,
  calculationsData: PropTypes.shape({
    currentCurrency: PropTypes.shape({
      currency: PropTypes.string,
      currencyCode: PropTypes.string,
      country: PropTypes.string,
      symbol: PropTypes.string,
    }),
    design: PropTypes.shape({
      kWhConsumedByDesign: PropTypes.number,
      costPerDesign: PropTypes.number,
      cutPower: PropTypes.shape({
        porcentaje_trabajo: PropTypes.number,
        corriente_maxima: PropTypes.number,
        voltaje: PropTypes.number,
        producto: PropTypes.arrayOf(PropTypes.string),
        id_consumo: PropTypes.string,
        potencia_kwh: PropTypes.number,
      }),
      cutWorkTime: PropTypes.number,
      designLength: PropTypes.number,
      designWidth: PropTypes.number,
      designsPerPiece: PropTypes.number,
      designsPerSheet: PropTypes.number,
      engravePower: PropTypes.shape({
        porcentaje_trabajo: PropTypes.number,
        corriente_maxima: PropTypes.number,
        voltaje: PropTypes.number,
        producto: PropTypes.PropTypes.arrayOf(PropTypes.string),
        id_consumo: PropTypes.string,
        potencia_kwh: PropTypes.number,
      }),
      engraveWorkTime: PropTypes.number,
      typeOfWork: PropTypes.string,
    }),
    imgDesign: PropTypes.shape({
      base64: PropTypes.string,
      filename: PropTypes.string,
      type: PropTypes.string,
      completeBase64: PropTypes.string,
    }),
    machineConsumptions: arrayOf(PropTypes.shape({
      corriente_maxima: PropTypes.number,
      id_consumo: PropTypes.string,
      porcentaje_trabajo: PropTypes.number,
      potencia: PropTypes.number,
      potencia_kwh: PropTypes.number,
      producto: PropTypes.arrayOf(PropTypes.string),
      voltaje: PropTypes.number,
    })),
    machine: PropTypes.shape({
      name: PropTypes.string,
      witdhCut: PropTypes.number,
      lengthCut: PropTypes.number,
      pipe: PropTypes.shape({
        pipeName: PropTypes.string,
        durability: PropTypes.number,
        price: PropTypes.number,
        costPerHour: PropTypes.number,
      }),
    }),
    material: PropTypes.shape({
      pieceArea: PropTypes.number,
      totalPiecesPerSheet: PropTypes.number,
      costPerPiece: PropTypes.number,
      values: PropTypes.arrayOf(PropTypes.shape({
        isUsingSavedMaterial: PropTypes.bool,
        name: PropTypes.string,
        cost: PropTypes.number,
        width: PropTypes.number,
        length: PropTypes.number,
        thickness: PropTypes.number,
      })),
    }),
  }).isRequired,
  setCalculationsData: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => (
  {
    view: state.view,
    calculationsData: state.calculationsData,
  });

const mapDispatchToProps = (dispatch) => ({
  setView: (values) => dispatch({
    type: 'SET_VIEW',
    payload: values,
  }),
  setCalculationsData: (values) => dispatch({
    type: 'SET_CALCULATIONS_DATA',
    payload: values,
  }),
});

export default connect(mapStateToProps, mapDispatchToProps)(SelectDesignView);
